import React, { useState, useEffect } from "react";
import checkgif from "../../assets/gif/loading-gif.gif";
import close from "../../assets/icons/close.svg";
import { useWebSocket } from "../../Utils/WebSocketHooks";
import Notifier from "../../Utils/notify";

export const WaitFeeApprovalsModal = ({ isOpen, onClose, onStatusChange, studentResponse }) => {
  const [status, setStatus] = useState({
    sent: false,
    delivered: false,
    read: false,
  });
  const [finalStatus, setFinalStatus] = useState(null); // "approved" or "rejected"
  const [canClose, setCanClose] = useState(false);


  const wsBaseUrl = process.env.REACT_APP_API_WSS_URL;



  const { readyState, connect, disconnect } = useWebSocket(wsBaseUrl, {
    reconnect: false,
    onOpen: () => console.log("✅ Connected to WebSocket"),
    onMessage: (data) => {

      // WhatsApp status updates
      if (data?.type === "whatsapp_webhook" && data?.data?.type === "message_status_update") {
        switch (data.data.status) {
          case "SENT":
            setStatus(prev => ({ ...prev, sent: true }));
            break;
          case "DELIVERED":
            setStatus(prev => ({ ...prev, sent: true, delivered: true }));
            break;
          case "READ":
            setStatus(prev => ({ ...prev, sent: true, delivered: true, read: true }));
            break;
          default:
            break;
        }
      }

      // Backend approval / rejection
      if (data?.data?.status) {
        const backendStatus = data.data.status.toLowerCase();
        if (backendStatus === "approved") {
          setFinalStatus("approved");
          Notifier.success("Fee plan approved successfully!");
          onStatusChange?.("approved");
        } else if (backendStatus === "rejected") {
          setFinalStatus("rejected");
          Notifier.error("Fee plan was rejected!");
          onStatusChange?.("rejected"); // 🔥 trigger refresh
        }
      }
    },
    onClose: () => console.log("🔌 WebSocket disconnected"),
    onError: (err) => console.error("⚠️ WebSocket error:", err),
  });

  useEffect(() => {
    if (isOpen) connect();
    else disconnect();
  }, [isOpen, connect, disconnect]);


  useEffect(() => {
    if (finalStatus) {
      const timer = setTimeout(() => {
        setCanClose(true);
        onClose(); // automatically close modal after 20 sec
      }, 20000);
      return () => clearTimeout(timer);
    }
  }, [finalStatus, onClose]);


  if (!isOpen) return null;

  const Step = ({ active, label, rejected }) => (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <div
        style={{
          width: 16,
          height: 16,
          borderRadius: "50%",
          border: "2px solid #999",
          backgroundColor: rejected ? "red" : active ? "#4caf50" : "transparent",
          marginBottom: 5,
        }}
      />
      <span style={{ fontSize: 12, color: rejected ? "red" : active ? "#000" : "#999" }}>{label}</span>
    </div>
  );

  return (
    <div className="modal-overlay">
      <div
        className="modal-content"
        style={{
          position: "relative",
          width: "80%",
          maxWidth: "500px",
          borderRadius: "12px",
          padding: 20,
        }}
      >
        <button
          onClick={onClose}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            position: "absolute",
            top: 10,
            right: 10,
          }}
        >
          <img src={close} alt="close" width="18" />
        </button>

        {/* <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="28"
        
          onClick={(e) => {
            e.stopPropagation();

            const urlToCopy = studentResponse?.signed_urls?.[0]?.signed_url; // pick first element
            if (urlToCopy) {
              navigator.clipboard.writeText(urlToCopy);
              Notifier.success("URL copied!");
            } else {
              Notifier.error("No URL available to copy.");
            }
          }}
          style={{ cursor: 'pointer' }}
          height="28"><g id="SVGRepo_bgCarrier" stroke-width="0"
          > <title>Copy Url</title>
          </g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M15.24 2H11.3458C9.58159 1.99999 8.18418 1.99997 7.09054 2.1476C5.96501 2.29953 5.05402 2.61964 4.33559 3.34096C3.61717 4.06227 3.29833 4.97692 3.14701 6.10697C2.99997 7.205 2.99999 8.60802 3 10.3793V16.2169C3 17.725 3.91995 19.0174 5.22717 19.5592C5.15989 18.6498 5.15994 17.3737 5.16 16.312L5.16 11.3976L5.16 11.3024C5.15993 10.0207 5.15986 8.91644 5.27828 8.03211C5.40519 7.08438 5.69139 6.17592 6.4253 5.43906C7.15921 4.70219 8.06404 4.41485 9.00798 4.28743C9.88877 4.16854 10.9887 4.1686 12.2652 4.16867L12.36 4.16868H15.24L15.3348 4.16867C16.6113 4.1686 17.7088 4.16854 18.5896 4.28743C18.0627 2.94779 16.7616 2 15.24 2Z" fill="#7F56DA"></path> <path d="M6.6001 11.3974C6.6001 8.67119 6.6001 7.3081 7.44363 6.46118C8.28716 5.61426 9.64481 5.61426 12.3601 5.61426H15.2401C17.9554 5.61426 19.313 5.61426 20.1566 6.46118C21.0001 7.3081 21.0001 8.6712 21.0001 11.3974V16.2167C21.0001 18.9429 21.0001 20.306 20.1566 21.1529C19.313 21.9998 17.9554 21.9998 15.2401 21.9998H12.3601C9.64481 21.9998 8.28716 21.9998 7.44363 21.1529C6.6001 20.306 6.6001 18.9429 6.6001 16.2167V11.3974Z" fill="#7F56DA"

          ></path> </g></svg> */}

        <div style={{ textAlign: "center" }}>
          <img src={checkgif} alt="waiting" style={{ width: 200, height: 200 }} />

          {/* Status Steps */}
          <div style={{ display: "flex", justifyContent: "space-around", margin: "20px 0" }}>
            <Step active={status.sent} label="Sent" />
            <Step active={status.delivered} label="Delivered" />
            <Step active={status.read} label="Read" />
            <Step
              active={finalStatus === "approved" || finalStatus === "rejected"}
              rejected={finalStatus === "rejected"}
              label={
                finalStatus === "approved"
                  ? "Approved"
                  : finalStatus === "rejected"
                    ? "Rejected"
                    : "Approval"
              }
            />
          </div>

          {/* Final status message */}
          {finalStatus && (
            <p style={{ fontSize: 14, fontWeight: "bold", color: finalStatus === "rejected" ? "red" : "#7F56DA" }}>
              Fee plan has been {finalStatus}. You can close this  now.
            </p>
          )}

          {/* WebSocket status */}
          <p style={{ fontSize: 13, color: "#666" }}>
            WebSocket status:{" "}
            {readyState === 0
              ? "Connecting..."
              : readyState === 1
                ? "Connected"
                : readyState === 2
                  ? "Closing..."
                  : readyState === 3
                    ? "Closed"
                    : "Not connected"}
          </p>
          {/* Copy URL icon always visible */}



        </div>
      </div>
    </div>
  );
};


